import { useContext } from 'react';

import LeafletMapContext from './LeafletMapContext';

const useLeafletMap = () => useContext(LeafletMapContext);

export default useLeafletMap;
